import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import accessToken from "../../helpers/jwt-token-access/accessToken";
import { Row, Col, Card, CardBody, Button, Label, Modal } from "reactstrap";
import { AvForm, AvField } from "availity-reactstrap-validation";
import Select from "react-select";
import { MDBDataTable } from "mdbreact";
import moment from "moment";
import "./ManagementDetails.scss";
import Breadcrumb from "../../components/Common/Breadcrumb";
import Pagination from "@mui/material/Pagination";
import { CSVLink } from "react-csv";
import * as XLSX from 'xlsx'


function ManagementDetails() {
  const [masterObj, setmasterObj] = useState({ start: 1, from_date: "", to_date: "", from_time: "", to_time: "" });
  const [selecetdpackage, setselecetdpackage] = useState(null);
  const [selectPackageType, setselectPackageType] = useState(null);
  const [packageoptions, setpackageoptions] = useState([]);
  const [instituteOptions, setInstituteOptions] = useState([]);
  const [selectedInstitute, setSelectedInstitute] = useState(null);
  const [dataToBeExported, setDataToBeExported] = useState([]);
  const API_URL = process.env.REACT_APP_APIURL || "http://localhost:3099/";
  const [tableDetails, settableDetails] = useState([]);
  const [exportLoader, setExportLoader] = useState(false);

  // Pagination
  const [searchValue, setSearchValue] = useState([])
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [PerPageCount, setPerPageCount] = useState(10)
  const [indexOfLastTransfer, setindexOfLastTransfer] = useState(currentPage * PerPageCount)
  const [indexOfFirstTransfer, setindexOfFirstTransfer] = useState(indexOfLastTransfer - PerPageCount)

  const package_id = masterObj?.package_id;
  const institute = masterObj?.institute;
  const from_date = masterObj?.from_date;
  const to_date = masterObj?.to_date;
  const from_time = masterObj?.from_time;
  const to_time = masterObj?.to_time;
  const package_type = masterObj?.package_type;



  function paginate(event, value) {
    // setmasterObj({ ...masterObj, start: value });
    setCurrentPage(value);
    const indexOfLastTransfer = value * PerPageCount;
    const indexOfFirstTransfer = indexOfLastTransfer - PerPageCount;
    setindexOfFirstTransfer(indexOfFirstTransfer);
    setindexOfLastTransfer(indexOfLastTransfer)
    fetchAllManagmentDetails(searchValue, package_id, institute, from_date, to_date, from_time, to_time, package_type, value, PerPageCount)
  }

  const resetPaginate = () => {
    setCurrentPage(1)
    const indexOfLastTransfer = 10;
    const indexOfFirstTransfer = 1;
    setindexOfFirstTransfer(indexOfFirstTransfer)
    setindexOfLastTransfer(indexOfLastTransfer)
  }

  const handleSearch = (value) => {
    setSearchValue(value)
    resetPaginate()
    fetchAllManagmentDetails(value, package_id, institute, from_date, to_date, from_time, to_time, package_type)
  }

  useEffect(() => {
    if (tableDetails?.length === 0 && indexOfFirstTransfer !== 0) {
      resetPaginate()
      fetchAllManagmentDetails(searchValue, package_id, institute, from_date, to_date, from_time, to_time, package_type, currentPage, PerPageCount)
    }
  }, [])


  useEffect(() => {
    fetchAllManagmentDetails(searchValue);
  }, [])


  useEffect(() => {
    // fetch_all_package();
    fetch_all_institute();
  }, [masterObj]);



  const fetch_all_institute = () => {
    axios
      .get(`${API_URL}institute/options`, {
        headers: {
          "x-access-token": accessToken,
        },
      })
      .then((res) => {
        let institute_data =
          res.data.data &&
          res.data.data.map((el) => {
            return {
              label: el?.inst_name,
              value: el?._id,
            };
          });
        setInstituteOptions([
          {
            options: institute_data,
          },
        ]);
      });
  };

  const fetch_all_package = (id) => {
    axios
      .get(`${API_URL}package/package-name-options-list?packageType=${id}`, {
        headers: {
          "x-access-token": accessToken,
        },
      })
      .then((res) => {
        let result = res.data.data;
        let packagedata = result.map((item) => {
          return {
            label: item?.packageName,
            value: item?._id,
            noOfResume: item?.noOfResume,
            noOfJobPort: item?.noOfJobPort,
            noOfServices: item?.noOfServices,
            amount: item?.amount,
            validity: item?.validity,
          };
        });
        setpackageoptions(packagedata);
      });
  };

  const data = {
    columns: [
      {
        label: "#",
        field: "id",
        sort: "asc",
        width: 150,
      },
      {
        label: "Date",
        field: "date1",
        sort: "asc",
        width: 150,
      },
      {
        label: "Time",
        field: "time1",
        sort: "asc",
        width: 150,
      },
      {
        label: "Institute",
        field: "management1",
        sort: "asc",
        width: 150,
      },
      {
        label: "Package",
        field: "package_name",
        sort: "asc",
        width: 150,
      },
      {
        label: "Amount (Rs)",
        field: "amount",
        sort: "asc",
        width: 150,
      },
      {
        label: "Expiry",
        field: "date2",
        sort: "asc",
        width: 150,
      },
      {
        label: "Remark",
        field: "remarkfield",
        sort: "asc",
        width: 150,
      },
    ],
    rows: tableDetails,
  };

  function handleChange(selected, name) {
    let package_id = masterObj?.package_id ? masterObj?.package_id : '';
    let institute = masterObj?.institute ? masterObj?.institute : "";
    let from_date = masterObj?.from_date ? masterObj?.from_date : "";
    let to_date = masterObj?.to_date ? masterObj?.to_date : "";
    let from_time = masterObj?.from_time ? masterObj?.from_time : "";
    let to_time = masterObj?.to_time ? masterObj?.to_time : "";
    let package_type = masterObj?.package_type ? masterObj?.package_type : "";

    resetPaginate()
    switch (name) {
      case "packageType":
        setselectPackageType(selected);
        setselecetdpackage(null);
        fetch_all_package(selected.value);
        setmasterObj({ ...masterObj, package_type: selected.value });
        fetchAllManagmentDetails(searchValue, package_id, institute, from_date, to_date, from_time, to_time, selected.value)
        break;
      case "package_id":
        setselecetdpackage(selected);
        setmasterObj({ ...masterObj, package_id: selected.value });
        fetchAllManagmentDetails(searchValue, selected.value, institute, from_date, to_date, from_time, to_time, package_type)
        break;
      case "institute":
        setSelectedInstitute(selected);
        setmasterObj({ ...masterObj, institute: selected.value });
        fetchAllManagmentDetails(searchValue, package_id, selected.value, from_date, to_date, from_time, to_time, package_type)
        break;


      default:
        break;
    }
  }

  function hnadledate(e) {
    if (e.target.name == "from_date") {
      var date1 = e.target.value;
      var date2 = masterObj?.to_date;
    } else {
      var date1 = masterObj?.from_date;
      var date2 = e.target.value;
    }
    const package_id = masterObj?.package_id;
    const institute = masterObj?.institute;
    const from_time = masterObj?.from_time;
    const to_time = masterObj?.to_time;
    const package_type = masterObj?.package_type;

    let toDate = moment(date1);
    let fromDate = moment(date2);
    let result = fromDate.diff(toDate, "days");

    if (result + 1 <= 0) {
      setmasterObj({
        ...masterObj,
        [e.target.name]: e.target.value,
        ["to_date"]: "",
      });
      date2 = "";
    } else {
      setmasterObj({
        ...masterObj,
        [e.target.name]: e.target.value,
      });
    }
    resetPaginate();
    fetchAllManagmentDetails(
      searchValue,
      package_id,
      institute,
      date1,
      date2,
      from_time,
      to_time,
      package_type,
    );

  }


  function hnadletime(e) {
    if (e.target.name == "from_time") {
      var time1 = e.target.value;
      var time2 = masterObj?.to_time;
    } else {
      var time1 = masterObj?.from_time;
      var time2 = e.target.value;
    }
    const package_id = masterObj?.package_id;
    const institute = masterObj?.institute;
    const from_date = masterObj?.from_date;
    const to_date = masterObj?.to_date;
    const package_type = masterObj?.package_type;

    let toTime = moment(time1);
    let fromTime = moment(time2);
    let result = fromTime.diff(toTime, "days");

    if (result + 1 <= 0) {
      setmasterObj({
        ...masterObj,
        [e.target.name]: e.target.value,
        ["to_time"]: "",
      });
      time2 = "";
    } else {
      setmasterObj({
        ...masterObj,
        [e.target.name]: e.target.value,
      });
    }
    resetPaginate();
    fetchAllManagmentDetails(
      searchValue,
      package_id,
      institute,
      from_date,
      to_date,
      time1,
      time2,
      package_type
    );
  }

  function handleBlurRemark(id, e) {
    let data = e.target.value;
    axios
      .post(
        `${API_URL}account/institute/table/update/remarks`,
        {
          _id: id,
          remarks: data,
        },
        {
          headers: {
            "x-access-token": accessToken,
          },
        }
      )
      .then((res) => {
      });
  }

  function fetchAllManagmentDetails(
    searchValue = "",
    package_id = "",
    institute = "",
    from_date = "",
    to_date = "",
    from_time = "",
    to_time = "",
    package_type = "",
    start = 1,
    limit = 10,
  ) {
    var url = `${API_URL}account/institute/table`;

    url =
      url +
      "?search=" +
      searchValue +
      "&package_id=" +
      package_id +
      "&institute=" +
      institute +
      "&from_date=" +
      from_date +
      "&to_date=" +
      to_date +
      "&from_time=" +
      from_time +
      "&to_time=" +
      to_time +
      "&package_type=" +
      package_type +
      "&start=" +
      start +
      "&limit=" +
      limit;


    axios
      .get(url, {
        headers: {
          "x-access-token": accessToken,
        },
      }
      )
      .then((res) => {
        let dataToBeExported = [];
        let result = res.data.data;
        setTotalPages(res.data.count);
        let tabledata = [];
        let id = (start - 1) * limit;
        result.map((item, index) => {
          let exportItem = {};
          id++;
          item.id = id;
          item.date1 = moment(item?.actived_date).format("DD-MM-YYYY");
          item.date2 = moment(item?.expiry).format("DD-MM-YYYY");
          item.time1 = moment(item?.activated_time, "hhmmss").format("hh:mm A");
          item.remarkfield = (
            <div>
              <AvForm>
                <AvField
                  rows="1"
                  name="remarks"
                  type="textarea"
                  value={item.remarks}
                  onBlur={(e) => {
                    handleBlurRemark(item._id, e);
                  }}
                />
              </AvForm>
            </div>
          );
          item.management1 = (
            <div>
              <a href={`/institute/${item.management_regno}`} target="blank">
                {item?.management}
              </a>
            </div>
          );
          tabledata.push(item);

          // exportItem.Id = item.id;
          // exportItem.Date = item.date1;
          // exportItem.Time = item.time1;
          // exportItem.Institute = item.management;
          // exportItem.Package = item.package_name;
          // exportItem.Expiry = item.date2;
          // exportItem.Amount = item.amount;
          // exportItem.Remark = item.remarks;

          dataToBeExported.push(exportItem)
        });
        settableDetails(tabledata);
        setDataToBeExported(dataToBeExported)

        // handleApiExport(searchValue, package_id, institute, from_date, to_date, from_time, to_time, package_type)
      });
  }

  // function handleApiCall() {
  //   axios.post(`${API_URL}institute/log/creation`, { type: 2 }, {
  //     headers: {
  //       "x-access-token": accessToken
  //     }
  //   }).then((res) => {
  //   })
  // }

  const reset = () => {
    setselectPackageType(null)
    setselecetdpackage(null)
    setSelectedInstitute(null)
    setpackageoptions([])
    setmasterObj({
      from_date: "",
      to_date: "",
      from_time: "",
      to_time: ""
    })
    fetchAllManagmentDetails()
  }

  const handleApiCall = async (
    search = searchValue || "",
    package_id = masterObj?.package_id || "",
    institute = masterObj?.institute || "",
    from_date = masterObj?.from_date || "",
    to_date = masterObj?.to_date || "",
    from_time = masterObj?.from_time || "",
    to_time = masterObj?.to_time || "",
    package_type = masterObj?.package_type || "",) => {
    setExportLoader(true)

    var url = `${API_URL}account/institute/table/export`;

    url =
      url +
      "?search=" +
      search +
      "&package_id=" +
      package_id +
      "&institute=" +
      institute +
      "&from_date=" +
      from_date +
      "&to_date=" +
      to_date +
      "&from_time=" +
      from_time +
      "&to_time=" +
      to_time +
      "&package_type=" +
      package_type;
    let dataToBeExported = [];

    await axios
      .get(url, {
        headers: {
          "x-access-token": accessToken,
        },
      }).then(res => {
        let result = res.data.data;
        result &&
          result.map((el, indx) => {

            let exportItem = {};
            exportItem.Id = indx + 1;
            exportItem.Date = moment(el.actived_date).format("DD-MM-YYYY");
            exportItem.Time = moment(el.activated_time, "hh:mm s").format("hh:mm a");
            exportItem.Institute = el.management;
            exportItem.Package = el.package_name;
            exportItem.Expiry = moment(el.expiry).format("DD-MM-YYYY");
            exportItem.Amount = el.amount;
            exportItem.Remark = el.remarks;

            dataToBeExported.push(exportItem)
          })
        // setDataToBeExported(dataToBeExported)
        setExportLoader(false)
      })
    return dataToBeExported

  }

  const jsonToExcel = (
    jsonArray,
    sheetName = moment().format("DDMMYYhhmmss")
  ) => {
    // Create a worksheet
    const ws = XLSX.utils.json_to_sheet(jsonArray)

    // Create a workbook
    const wb = XLSX.utils.book_new()
    XLSX.utils.book_append_sheet(wb, ws, sheetName)

    // Save to a file
    XLSX.writeFile(wb, `${sheetName}.xlsx`)
  }

  async function handleExport() {
    const data = await handleApiCall()

    jsonToExcel(data, `appregisterd`)
  }


  return (
    <>
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumb title="Home" breadcrumbItem="Subscribed Institute" />

          <Row>
            <Card>
              <CardBody>
                <AvForm>
                  <Row>
                    <Col md="2">
                      <div className="mb-3">
                        <Label>Package Type</Label>
                        <Select
                          name="packageTypes"
                          classNamePrefix="select2-selection"
                          value={selectPackageType}
                          options={[
                            { label: "Resume Wise", value: 0 },
                            { label: "Job Port Wise", value: 1 },
                            { label: "Service Wise", value: 2 },
                          ]}
                          onChange={(selected) => {
                            handleChange(selected, "packageType");
                          }}
                        />
                      </div>
                    </Col>
                    <Col md="3">
                      <div className="mb-3">
                        <Label>Package</Label>
                        <Select
                          name="package_id"
                          value={selecetdpackage}
                          options={packageoptions}
                          onChange={(selected) => {
                            handleChange(selected, "package_id");
                          }}
                        />
                      </div>
                    </Col>
                    <Col md="2">
                      <div className="mb-3">
                        <Label>Institute</Label>
                        <Select
                          name="institute"
                          value={selectedInstitute}
                          onChange={(selected) => {
                            handleChange(selected, "institute");
                          }}
                          options={instituteOptions}
                          classNamePrefix="select2-selection"
                        />
                      </div>
                    </Col>
                    <Col md="2">
                      <div className="mb-3">
                        <Label>From Date</Label>
                        <AvField
                          name="from_date"
                          type="date"
                          onChange={(e) => {
                            hnadledate(e);
                          }}
                          value={masterObj?.from_date}
                        />
                      </div>
                    </Col>
                    <Col md="2">
                      <div className="mb-3">
                        <Label>To Date</Label>
                        <AvField
                          name="to_date"
                          type="date"
                          onChange={(e) => {
                            hnadledate(e);
                          }}
                          value={masterObj?.to_date}
                        />
                      </div>
                    </Col>
                    <Col md="2">
                      <div className="mb-3">
                        <Label>From Time</Label>
                        <AvField
                          name="from_time"
                          type="time"
                          onChange={(e) => {
                            hnadletime(e);
                          }}
                          value={masterObj?.from_time}
                        />
                      </div>
                    </Col>
                    <Col md="2">
                      <div className="mb-3">
                        <Label>To Time</Label>
                        <AvField
                          name="to_time"
                          type="time"
                          onChange={(e) => {
                            hnadletime(e);
                          }}
                          value={masterObj?.to_time}
                        />
                      </div>
                    </Col>
                    <Col md="2">
                      <div className="mt-4" style={{ paddingTop: "6px", display: "flex" }} >
                        <Button onClick={() => handleExport()} disabled={exportLoader ? "disabled" : ""} color="success" type="">
                          {/* <CSVLink
                            data={dataToBeExported}
                            filename={"Appregistered.xls"}
                            style={{ color: "white" }}
                          >
                            Export

                          </CSVLink> */}
                          Export
                        </Button>

                        <Button color="danger" type="submit" style={{ marginLeft: "25px" }} onClick={() => reset()}>Reset</Button>
                      </div>
                    </Col>
                  </Row>
                </AvForm>
              </CardBody>
            </Card>
          </Row>
          <Row>
            <Card>
              <CardBody>
                <Col md="12">
                  <MDBDataTable
                    id="managementTable"
                    responsive
                    bordered
                    data={data}
                    searching={true}
                    entries={PerPageCount}
                    paging={false}
                    info={false}
                    disableRetreatAfterSorting={true}
                    onSearch={(value) => handleSearch(value)}
                  />
                  {totalPages > 10 && (
                    <div
                      className="pagination-div">
                      <div className="page-details">
                        Showing {((currentPage - 1) * PerPageCount) + 1} to{" "}
                        {Math.min(currentPage * PerPageCount, totalPages)} of{" "}
                        {totalPages} entries
                      </div>
                      <Pagination
                        color="standard"
                        shape="rounded"
                        defaultPage={1}
                        count={Math.ceil(totalPages / PerPageCount)}
                        page={currentPage}
                        onChange={paginate}
                        size="large"
                        info={true}
                      />
                    </div>
                  )}
                </Col>
              </CardBody>
            </Card>
          </Row>
        </div>
      </div>
    </>
  );
}

export default ManagementDetails;
